import React, { useState } from "react";
import { useAppDispatch } from "../../redux/hooks/hooks";
import { DocumentItem } from "../../api/models/document-item";
import { fetchCreateDocumentAsync } from "../../redux/feature/document/document-slice";
import HeaderPanel from "../layout/HeaderPanel";
import { CREATE_DOCUMENT_NOTIFICATION } from "../../utils/constants/notification";
import NotificationManager from "../../common/notification/NotificationManager";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { DocumentData, EditDocument } from "./EditDocument";
import LoadingManager from "../../common/loading/LoadingManager";
import { DOCUMENTS_LISTS } from "../../utils/constants/navigation";
import { navigate } from "../../redux/feature/general/navigation-slice";
import { defaultFormatting } from "../../utils/constants/formats";
import { mapDocumentDataToDocumentPartMetadata } from "../../utils/helpers/CustomXmlHelper";

const initialDocument: DocumentData = {
  description: undefined,
  name: undefined,
  root: true,
  multilinked: false,
  path: "",
  documentId: undefined,
  siteId: undefined,
  driveItemId: undefined,
  hasChildren: false,
  advanced: defaultFormatting,
  language: null,
  parameters: [],
  inheritableParameters: undefined,
  settings: {},
};

const NewDocument: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();

  const handleCreateDocument = async (input: DocumentData) => {
    LoadingManager.create(CREATE_DOCUMENT_NOTIFICATION);

    let item = dispatch(
      fetchCreateDocumentAsync({
        documentName: input.name,
        documentDescription: input.description,
        path: input.path,
        metadata: mapDocumentDataToDocumentPartMetadata(input),
        settings: input.settings,
      })
    );

    let documentItem: DocumentItem = await item.unwrap();
    LoadingManager.remove(CREATE_DOCUMENT_NOTIFICATION);

    if (!documentItem.error?.length) {
      NotificationManager.addNotification({
        title: formatMessage("cof.createdocument.createdocument"),
        message: formatMessage("cof.createdocument.message.success"),
        key: CREATE_DOCUMENT_NOTIFICATION,
        type: "success",
        closable: true,
        removeOnClose: true,
        isTemporary: true,
      });
      dispatch(navigate(DOCUMENTS_LISTS));
    } else return Promise.reject(new Error(JSON.stringify(documentItem.error)));
  };

  const [documentInfo, setDocumentInfo] = useState<{ name: string; index: string }>({
    name: undefined,
    index: "1",
  });
  const getHeaderText = () => {
    return documentInfo.index && documentInfo.index !== "1" && documentInfo.name
      ? formatMessage("cof.createdocument.newdocument") + " - " + documentInfo.name
      : formatMessage("cof.createdocument.newdocument");
  };

  return (
    <div>
      <HeaderPanel applyPadding>{getHeaderText()}</HeaderPanel>
      <div style={{ color: "var(--color-grey)", paddingLeft: "0.5rem", fontSize: "0.875rem" }}>
        {formatMessage("cof.createdocument.info")}
      </div>
      <EditDocument
        isEdit={false}
        onLastBackButton={undefined}
        getDocumentPartDetails={async () => {
          return {
            documentData: initialDocument,
          };
        }}
        onUpdateDocumentInfo={(info) => {
          setDocumentInfo((s) => ({
            ...s,
            name: info.name,
          }));
        }}
        onTabChange={(tabIndex) => {
          setDocumentInfo((s) => ({ ...s, index: tabIndex }));
        }}
        onSave={handleCreateDocument}
      />
    </div>
  );
};
export default NewDocument;
